import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="py-16 text-center text-white" style={{background: '#0A0F1A'}}>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {/* Logo with tagline (full brand statement) */}
                <Link to="/" className="inline-block mb-4">
                    <img src="/PettAI_logo.webp" alt="PettAI — Claim Your Brand Territory" className="h-48 w-auto mx-auto" />
                </Link>
                <p className="text-gray-400 text-base mt-4"><a href="https://pettaiapp.in" className="hover:text-amber-500 transition-colors">pettaiapp.in</a> using Smart Deep Neural Assessment methodology</p>
                <a href="mailto:contact@pettaiapp.in" className="text-amber-500 hover:underline text-base mt-2 inline-block">contact@pettaiapp.in</a>

                {/* Social Icons */}
                <div className="flex justify-center space-x-8 mt-8 mb-6">
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-500 cursor-pointer transition-colors"><FaLinkedin className="w-7 h-7" /></a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-500 cursor-pointer transition-colors"><FaTwitter className="w-7 h-7" /></a>
                    <a href="mailto:contact@pettaiapp.in" className="text-gray-400 hover:text-amber-500 cursor-pointer transition-colors"><FaEnvelope className="w-7 h-7" /></a>
                </div>

                {/* Footer Links */}
                <div className="flex flex-col sm:flex-row justify-center items-center flex-wrap gap-y-2 gap-x-6 text-gray-400 text-base mt-4">
                    <a href="/#how-it-works" className="hover:text-amber-500 transition-colors">About</a>
                    <a href="mailto:contact@pettaiapp.in" className="hover:text-amber-500 transition-colors">Contact</a>
                    <Link to="/partners" className="hover:text-amber-500 transition-colors">Partner Program</Link>
                    <Link to="/privacy" className="hover:text-amber-500 transition-colors">Privacy Policy</Link>
                    <Link to="/terms" className="hover:text-amber-500 transition-colors">Terms of Service</Link>
                    <Link to="/partner-terms" className="hover:text-amber-500 transition-colors">Partner Terms</Link>
                </div>

                {/* Copyright */}
                <p className="text-gray-600 text-sm mt-8">&copy; 2026 PettAI &middot; pettaiapp.in. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
